
export default function ArrowRightIcon() {
    return (
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.66458 0L0.335417 0C0.0555991 0 -0.100645 0.294357 0.0726438 0.495312L4.73723 5.88431C4.87074 6.03856 5.12784 6.03856 5.26277 5.88431L9.92736 0.495312C10.1006 0.294357 9.9444 0 9.66458 0Z" fill="currentColor"/>
        </svg>
        
    )
}